//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    textColor: {
      type: String,
      default: '#30324B'
    },
  },
}
